<script>
    import { FirebaseApp, Doc, Collection } from 'sveltefire';
    
    import firebase from "firebase/app";
    import 'firebase/firestore';

    var fid = '';
    var fsku = '';

    function open(id, sku)    {
        window.open('https://stadia.google.com/store/details/'+id+'/sku/'+sku, 'us');
        window.open('https://stadia.google.com/u/1/store/details/'+id+'/sku/'+sku, 'ca');
        window.open('https://stadia.google.com/u/2/store/details/'+id+'/sku/'+sku, 'eu');
        window.open('https://stadia.google.com/u/3/store/details/'+id+'/sku/'+sku, 'uk');
        window.open('https://stadia.google.com/u/4/store/details/'+id+'/sku/'+sku, 'se');
        window.open('https://stadia.google.com/u/5/store/details/'+id+'/sku/'+sku, 'dk');
        window.open('https://stadia.google.com/u/6/store/details/'+id+'/sku/'+sku, 'nk');
        window.open('https://stadia.google.com/u/7/store/details/'+id+'/sku/'+sku, 'hu');
        window.open('https://stadia.google.com/u/8/store/details/'+id+'/sku/'+sku, 'cz');
        window.open('https://stadia.google.com/u/9/store/details/'+id+'/sku/'+sku, 'pl');
    }
</script>

<p>This page is for developmental and debugging purposes. Yes, it's ugly—you weren't supposed to see this, but I was too lazy to isolate it from prod.</p>

<form class="pure-form">
    <input type="text" bind:value={fid} />
    <input type="text" bind:value={fsku} />
    <input type="submit" on:click={(e) => { e.preventDefault(); open(fid, fsku); }} />
</form>

<Collection idField={null} path='games' let:data> 
    {#each data as game}
        <a href={'https://stadia.google.com/store/details/'+game.id+'/sku/'+game.ref.id} on:click={(e) => { e.preventDefault();
            open(game.id, game.ref.id);
            e.target.classList.add('purple');
        }}>{game.title} — {game.ref.id}</a><br />
    {/each}
</Collection>